import { render, staticRenderFns } from "./c_banner.vue?vue&type=template&id=68da5b01&scoped=true"
import script from "./c_banner.vue?vue&type=script&lang=js"
export * from "./c_banner.vue?vue&type=script&lang=js"
import style0 from "./c_banner.vue?vue&type=style&index=0&id=68da5b01&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da5b01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68da5b01')) {
      api.createRecord('68da5b01', component.options)
    } else {
      api.reload('68da5b01', component.options)
    }
    module.hot.accept("./c_banner.vue?vue&type=template&id=68da5b01&scoped=true", function () {
      api.rerender('68da5b01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_banner.vue"
export default component.exports